<section class="login ks-card ks-rise-1" aria-labelledby="login-title">
  <header class="login__head">
    <span class="login__mark" aria-hidden="true"><i class="bi bi-shield-lock-fill"></i></span>
    <h1 class="login__brand">KeyStoreMan</h1>
    <p class="login__tag">Consola administrativa</p>
  </header>

  @if (firebaseMissing) {
    <div class="login__alert" role="alert">
      <i class="bi bi-exclamation-triangle-fill" aria-hidden="true"></i>
      <span>
        Falta configurar la app <strong>Web</strong> de Firebase. Completa
        <code>apiKey</code> y <code>appId</code> en <code>src/environments/environment.ts</code>
        antes de iniciar sesión.
      </span>
    </div>
  }

  <h2 id="login-title" class="login__title">Iniciar sesión</h2>
  <p class="login__subtitle">Accede con tu cuenta de perfil sudo.</p>

  <form class="login__form" [formGroup]="form" (ngSubmit)="submit()" novalidate>
    <div class="ks-form-group">
      <label class="ks-label" for="email">Correo electrónico</label>
      <input
        id="email"
        class="ks-field"
        type="email"
        inputmode="email"
        autocomplete="username"
        placeholder="nombre@empresa.com"
        formControlName="email"
        [attr.aria-invalid]="email.touched && email.invalid ? 'true' : null"
        [attr.aria-describedby]="email.touched && email.invalid ? 'email-error' : null" />

      @if (email.touched && email.hasError('required')) {
        <p class="ks-field-error" id="email-error">
          <i class="bi bi-exclamation-circle-fill" aria-hidden="true"></i>
          El correo electrónico es obligatorio.
        </p>
      } @else if (email.touched && email.hasError('email')) {
        <p class="ks-field-error" id="email-error">
          <i class="bi bi-exclamation-circle-fill" aria-hidden="true"></i>
          Escribe un correo electrónico válido.
        </p>
      }
    </div>

    <div class="ks-form-group">
      <label class="ks-label" for="password">Contraseña</label>

      <div class="login__password">
        <input
          id="password"
          class="ks-field"
          [type]="showPassword() ? 'text' : 'password'"
          autocomplete="current-password"
          placeholder="••••••••"
          formControlName="password"
          [attr.aria-invalid]="password.touched && password.invalid ? 'true' : null"
          [attr.aria-describedby]="password.touched && password.invalid ? 'password-error' : null" />

        <button
          type="button"
          class="login__reveal"
          [attr.aria-label]="showPassword() ? 'Ocultar la contraseña' : 'Mostrar la contraseña'"
          [attr.aria-pressed]="showPassword()"
          (click)="togglePassword()">
          <i class="bi" [class.bi-eye]="!showPassword()" [class.bi-eye-slash]="showPassword()" aria-hidden="true"></i>
        </button>
      </div>

      @if (password.touched && password.hasError('required')) {
        <p class="ks-field-error" id="password-error">
          <i class="bi bi-exclamation-circle-fill" aria-hidden="true"></i>
          La contraseña es obligatoria.
        </p>
      } @else if (password.touched && password.hasError('minlength')) {
        <p class="ks-field-error" id="password-error">
          <i class="bi bi-exclamation-circle-fill" aria-hidden="true"></i>
          La contraseña debe tener al menos 6 caracteres.
        </p>
      }
    </div>

    <button
      type="submit"
      class="ks-btn ks-btn--primary ks-btn--lg ks-btn--block"
      [disabled]="submitting() || firebaseMissing">
      @if (submitting()) {
        <span class="login__spinner" aria-hidden="true"></span>
        <span>Verificando…</span>
      } @else {
        <i class="bi bi-box-arrow-in-right" aria-hidden="true"></i>
        <span>Entrar</span>
      }
    </button>

    <p class="ks-field-error login__error" role="alert" [class.is-hidden]="!formError()">
      @if (formError()) {
        <i class="bi bi-exclamation-octagon-fill" aria-hidden="true"></i>
        <span>{{ formError() }}</span>
      }
    </p>
  </form>

  <p class="login__note">
    <i class="bi bi-info-circle" aria-hidden="true"></i>
    Esta consola no muestra ninguna credencial de la bóveda.
  </p>
</section>
